import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summaryData: null,
  companyCount: 0,
  totalCompanies: null,
};

const addressListingSlice = createSlice({
  name: "addressListing",
  initialState,
  reducers: {
    fetchAddressSummary(state, action) {
      state.loading = true;
    },
    fetchAddressSummarySuccess(state, action) {
      state.summaryData = action.payload.data.document;
      state.companyCount = action.payload.count;
      state.loading = false;
    },
    fetchAddressSummaryFailure(state, action) {
      state.loading = false;
    },
    fetchTotalCompanies(state, action) {
      state.loading = true;
    },
    fetchTotalCompaniesSuccess(state, action) {
      state.totalCompanies = action.payload.data.document;
      state.loading = false;
    },
    fetchTotalCompaniesFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = addressListingSlice;
